import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';
import { buildAffiliateContextAttribute } from '../utils';

export default function register(params) {
    const { baseUrl, brandId, country, credentials, uberToken, clientId, clientSecret, additionalHeaders } = params;

    invariant(baseUrl, 'baseUrl is a required param of register()');
    invariant(brandId, 'brandId is a required param of register()');
    invariant(country, 'country is a required param of register()');
    invariant(credentials, 'credentials is a required param of register()');
    invariant(clientId, 'clientId is a required param of register()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person?mode=self`;
    const affiliateContextAttribute = buildAffiliateContextAttribute();

    const body = JSON.stringify({
        // add the affiliate context attribute to credentials so we don't overwrite if present
        ...addContextAttributeToCredentials(addDobToCredentials(credentials), affiliateContextAttribute),
        x_userField1: 'Web',
    });

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'register',
    );
}

function addDobToCredentials(credentials) {
    const { dateOfBirthGroup, ...rest } = credentials || {};
    const { day, month, year } = dateOfBirthGroup || {};
    if (day && month) {
        return {
            ...rest,
            dateOfBirth: day && month ? `${day}-${month}-${year ? year : '1900'}` : '',
        };
    }
    return rest;
}

function addContextAttributeToCredentials(credentials, contextAttribute) {
    if (!credentials) {
        return { contextAttribute };
    }

    if (credentials.contextAttribute) {
        credentials.contextAttribute.push(...contextAttribute);
    } else if (contextAttribute.length > 0) {
        credentials.contextAttribute = contextAttribute;
    }

    return credentials;
}
